export class BlurShape {
	width: number;
	height: number
	left: number;
	top: number;
	active?: boolean;
	visible?: boolean;

	constructor() {
		this.visible = false;
		this.active = false;
	}
}

export class ShapeCoordinates {
		x: number;
		y: number;
		width: number;
		height: number;
	constructor() {
		this.width = 0;
		this.height = 0;
		this.x = 0;
		this.y = 0;
	}
}

export class CanvasOptions {
	offsetX?: number;
	offsetY?: number;
	width?: number;
	height?: number;
	scrollX?: number;
	scrollY?: number;

	constructor() {
		this.offsetX = 0;
		this.offsetY = 0;
		this.width = 0;
		this.height = 0;
		this.scrollX = 0;
		this.scrollY = 0;
	}
}
